import React from 'react';
import {useSelector} from 'react-redux';

import DynamicQuestionsComponent from './DynamicQuestions';

const DynamicQuestions = () => {
    const {dynamicQuestions} = useSelector((state) => state.destination);

    return <DynamicQuestionsComponent dynamicQuestions={dynamicQuestions} />;
};

DynamicQuestions.displayName = 'DynamicQuestions';

export default DynamicQuestions;
